import {ExamesNaviosModel} from "../navios/exames-navios.model";
import {ExamesDispositivosModel} from "../dispositivos/exames-dispositivos.model";

export class ExamesTesteSoproTripulanteModel {
  id?: number | string;
  id_teste_sopro?: number | string;
  ordem?: number;
  nome: string = '';
  id_cargo?: number | string = null;
  cargo_nome?: string = '';
  horario?: string = '';
  brac?: string = '0.00';
}

export class ExamesTesteSoproModel {
  id?: number | string;
  id_cliente?: number | string = null;
  id_status?: number | string = 1;
  id_navio?: number | string = null;
  id_local?: number | string = null;
  id_dispositivo?: number | string = null;
  navio_nome?: string = '';
  navio_imo?: string = '';
  porto_terminal?: string = '';
  data_hora_inicio?: string = '';
  data_hora_fim?: string = '';
  total_pessoas_testadas?: number = 0;
  master_nome?: string = '';
  master_data?: string = '';
  testemunha_nome?: string = '';
  testemunha_data?: string = '';
  inspetor_nome?: string = '';
  inspetor_data?: string = '';
  cliente?: any;
  navio?: ExamesNaviosModel;
  dispositivo?: ExamesDispositivosModel;
  local?: any;
  tripulantes?: ExamesTesteSoproTripulanteModel[] = [];
}



// WEBPACK FOOTER //
// ./src/app/exames/teste-sopro/exames-teste-sopro.model.ts